var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"transcription"}},[_c('split-text',{attrs:{"type":'words',"classname":'transcription-copy'}},[_vm._v(_vm._s(_vm.transcription))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }